<template>
    <div ref="section_container" id="section_container" class="container" :class="{
        'vertical': $store.state.is_horizontal == 0,
    }">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="live-is-over" :class="{
                    'vertical-s': $store.state.is_horizontal == 0
                }" v-if="isOver">
                    執筆ライブは終了しました。
                </div>
                <button class="btn btn-secondary btn-layout reset-vertical" @click="$emit('showLayout')">
                    <i class="fas fa-sliders-h"></i>
                    <span class="nowrap">あぁ</span>
                    <i class="fas fa-arrow-circle-down" v-if="is_recent"></i>
                </button>
                <div class="section mincho"
                    :class="sectionClass" v-if="section.body">
                    <div class="section-body indicator b-dark gothic" v-html="$filters.ruby(status)"></div>
                    <div class="book-title">
                        <h3 itemprop="title">
                            <span v-html="$filters.ruby(book.title)"></span>
                        </h3>
                        <h4 v-if="book.subtitle" itemprop="subtitle" :class="{'mx-2': $store.state.is_horizontal}">
                            {{book.subtitle}}
                        </h4>
                    </div>
                    <div class="section-title">
                        <h5 :class="[$store.getters.fontSize]" v-html="$filters.ruby(section.section_name)">
                        </h5>
                    </div>
                    <div class="section-body"
                        :class="[$store.getters.fontSize]"
                        v-html="$filters.ruby(section.body)"></div>
                    <div class="section-body indicator b-dark gothic" v-html="$filters.ruby(status)"></div>
                </div>
                <div class="live-is-over" :class="{
                    'vertical-s': $store.state.is_horizontal == 0
                }" v-if="isOver">
                    執筆ライブは終了しました。
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
#section_container {
    margin-top: 0px;
    max-width: 100%;
    min-height: 100vh;
    padding-top: 10px;
    .btn-layout {
        position: fixed;
        top: 1.5rem;
        right: 1.5rem;
    }
}
.vertical {
    justify-content: center;
    max-width: calc(100vw - 150px);
    overflow: auto;
    a:hover {
        text-decoration: overline;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
}
.section {
    max-width: 860px;
    margin: 0 auto;
    letter-spacing: .2rem;
    padding: 0 3.5rem 1rem;
    font-size: 1.2rem;
    transition: 0.3s ease;
    .font-s { font-size: 1.0rem; line-height: 2.2rem; }
    .font-m { font-size: 1.1rem; line-height: 2.4rem; }
    .font-l { font-size: 1.2rem; line-height: 2.6rem; }
    .font-x { font-size: 1.3rem; line-height: 2.8rem; }
    .font-h { font-size: 1.4rem; line-height: 3.0rem; }
    &.loading {
        color: transparent;
    }
    .book-title {
        padding: 2rem 2rem 1.5rem;
        margin: 0 auto;
        text-align: center;
        h3 {
            display: inline-block;
            font-size: 2rem;
            text-align: left;
        }
        h4 {
            display: inline-block;
            font-size: .9rem;
            color: #777;
            text-align: left;
        }
    }
    .book-caption {
        h3 {
            font-size: .65rem;
        }
        text-align: right;
        height: 2rem;
        padding-top: .5rem;
    }
    .section-title {
        margin: 2rem 0 4rem;
        text-align: center;
        h5 {
            text-align: left;
            display: inline-block;
            &.font-s { font-size: 1.4rem; }
            &.font-m { font-size: 1.5rem; }
            &.font-l { font-size: 1.6rem; }
            &.font-x { font-size: 1.8rem; }
            &.font-h { font-size: 2.0rem; }
        }
    }
    .hover-title {
        position: fixed;
        bottom: 2.3rem;
        left: 0;
        width: 100vw;
        text-align: center;
        writing-mode: horizontal-tb;
        text-orientation: none;
        line-height: .9rem;
    }
    .indicator {
        text-align: center;
        font-size: 0.9rem;
        margin: 1rem;
        border-radius: 2rem;
    }
    &.vertical-s {
        height: calc(100vh - 20px);
        max-width: 100%;
        padding: 14rem 1rem 14rem 1rem;
        .section-title {
            margin: 0 2rem;
            padding: 0 2rem;
        }
    }
}
.live-is-over {
    text-align: center;
    color: crimson;
    background-color: #bfbfbf;
    padding: 1rem;
    font-size: 1.3rem;
    &.vertical-s {
        height: calc(100vh - 20px);
    }
}
@media screen and (max-height: 1000px) {
    .section {
        &.vertical-s {
            height: calc(var(--vh, 100vh) - 20px);
            padding: 6rem 1rem 6rem 1rem;
        }
    }
}
@media screen and (max-width: 770px) {
    .section {
        padding: 0 .5rem 1rem;
        font-size: .9rem;
        .font-s { font-size: 0.9rem; line-height: 1.9rem; }
        .font-m { font-size: 1.0rem; line-height: 2.0rem; }
        .font-l { font-size: 1.1rem; line-height: 2.1rem; }
        .font-x { font-size: 1.2rem; line-height: 2.2rem; }
        .font-h { font-size: 1.3rem; line-height: 2.4rem; }
        &.vertical-s {
            height: calc(100vh - 80px);
            padding: 3.2rem 0 3.2rem 1rem;
        }
    }
    .col-lg-12 {
        padding: 0;
    }
    .vertical {
        max-width: 100% ;
    }
}
</style>

<script>
export default {
    data() {
        return {
            section: {},
            book: {},
            is_over: false,
            is_recent: false,
            routeWatcher: null,
        }
    },
    methods: {
        load() {
            axios.get("/live/episode/" + this.$route.params.id).then(res => {
                if (res.data.url) {
                    alert.warn("指定の本文はライブ配信が終了しました。公開ページへ遷移します。");
                    setTimeout(() => {location.href = res.data.url}, 1000);
                    return;
                }
                if (!this.section.id) {
                    this.section = res.data;
                }
                this.book = res.data.book;
                setInterval(this.refreshTimes, 5000);
            }).catch(err => {
                console.error(err.response);
                alert.err(err.response);
            });
        },
        refreshTimes() {
            // 開始時間と最終更新を更新する
            let created_at = this.section.livecast.created_at;
            let updated_at = this.section.livecast.updated_at;
            this.section.livecast.created_at = null;
            this.section.livecast.updated_at = null;
            if (!this.section.livecast.created_at) this.section.livecast.created_at = created_at;
            if (!this.section.livecast.updated_at) this.section.livecast.updated_at = updated_at;
        },
        connectChannel() {
            Echo.channel("live." + this.$route.params.id).listen("WriteNovel", (e) => {
                this.section = e.section;
                if (this.is_recent) {
                    setTimeout(() => {this.scrollBottom()});
                }
                this.is_over = false;
                if (!this.book.id) {
                    this.load();
                }
            }).listen("LiveIsOver", (e) => {
                this.is_over = true;
                if (this.is_recent) {
                    setTimeout(() => {this.scrollBottom()});
                }
            });
        },
        scrollBottom() {
            if (this.$store.state.is_horizontal) {
                let elm = document.documentElement;
                let bottom = elm.scrollHeight - elm.clientHeight;
                window.scroll(0, bottom);
            } else {
                let elm = this.$refs.section_container;
                elm.scrollLeft = (elm.scrollWidth - elm.clientWidth) * -1;
            }
        },
        onScroll(ev) {
            if (this.$store.state.is_horizontal) {
                let elm = document.documentElement;
                let bottom = elm.scrollHeight - elm.clientHeight - 10;
                if (bottom <= window.scrollY) {
                    this.is_recent = true;
                } else {
                    this.is_recent = false;
                }
            } else {
                let elm = this.$refs.section_container;
                elm.scrollLeft = elm.scrollLeft - ev.deltaY;
                if (((elm.scrollWidth - elm.clientWidth) * -1) <= elm.scrollLeft) {
                    this.is_recent = true;
                } else {
                    this.is_recent = false;
                }
            }
        },
        getSize() {
            const vh = (window.innerHeight);
            if (document.querySelector(".vertical-s")) {
                document.querySelector(".vertical-s").style.setProperty('--vh', `${vh}px`);
            } else {
                setTimeout(() => this.getSize(), 300);
            }
        },
    },
    computed: {
        isOver() {
            return this.is_over || this.section?.livecast?.deleted_at;
        },
        start_at() {
            return this.section?.livecast?.created_at || this.section.created_at;
        },
        update_at() {
            return this.section?.livecast?.updated_at || this.section.updated_at;
        },
        status() {
            return "開始：" + moment(this.section.livecast.created_at).fromNow() + "／最終更新：" + moment(this.section.livecast.updated_at).fromNow();
        },
        sectionClass() {
            const cls = {};
            if (this.$store.state.is_horizontal == 0) {
                cls["vertical-s"] = true;
            }
            if (this.$store.state.font) {
                cls[this.$store.state.font] = true;
            }
            return cls;
        },
    },
    mounted() {
        $(window).on("resize", this.getSize);
        this.getSize();
        document.querySelector("#section_container").onwheel = this.onScroll;
        this.load();
        this.connectChannel();
        this.routeWatcher = this.$watch('$route', (o, n) => {
            this.section = {};
            this.book = {};
            this.is_over = false;
            this.load();
            this.connectChannel();
        });
        this.useHead({
            title: "執筆ライブ | 貸し本棚ヘルプ",
        });
    },
    beforeRouteLeave(to, from) {
        Echo.leaveChannel("live." + this.$route.params.id);
        this.routeWatcher();
    },
    destroyed() {
        $(window).off("resize");
    },
}
</script>